import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import swal from "sweetalert";
import { useTranslation } from "react-i18next";
import {
  createUserByAdmin,
  listUsers,
  selectUsersCreateError,
  selectUsersCreateLoading,
  selectUsersCreateMessage,
} from "../userSlice";

const UsersCreatePage = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const createLoading = useSelector(selectUsersCreateLoading);
  const adminAccess = useSelector((state) => state.auth?.adminAccess);
  const createError = useSelector(selectUsersCreateError);
  const createMessage = useSelector(selectUsersCreateMessage);
  const [successMessage, setSuccessMessage] = useState("");
  const [permissionError, setPermissionError] = useState("");
  const [formState, setFormState] = useState({
    fullName: "",
    email: "",
    tempPassword: "",
    role: "",
    businessId: "",
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async () => {
    if (!adminAccess) {
      setPermissionError(t("admin_common.permission_denied"));
      return;
    }
    setSuccessMessage("");
    setPermissionError("");
    const payload = {
      fullName: formState.fullName?.trim() || "",
      email: formState.email?.trim() || "",
      tempPassword: formState.tempPassword?.trim() || "",
      role: formState.role?.trim() || "",
      businessId: formState.businessId?.trim() || "",
    };
    if (!payload.fullName || !payload.email || !payload.tempPassword) {
      swal(
        t("admin_users_pages.missing_fields_title"),
        t("admin_users_pages.missing_fields_message"),
        "error"
      );
      return;
    }
    if (payload.tempPassword.length < 6) {
      swal(
        t("admin_users_pages.missing_fields_title"),
        t("admin_users_pages.password_length_message"),
        "error"
      );
      return;
    }
    try {
      await dispatch(createUserByAdmin(payload)).unwrap();
      await dispatch(listUsers());
      setSuccessMessage(t("admin_users_pages.create_success_message"));
      setFormState({
        fullName: "",
        email: "",
        tempPassword: "",
        role: "",
        businessId: "",
      });
    } catch (error) {
      // Error is handled in slice state
    }
  };

  return (
    <>
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-body">
            <h4 className="card-title">{t("admin_users_pages.create_title")}</h4>
            {permissionError && (
              <div className="alert alert-danger">{permissionError}</div>
            )}
            {successMessage && (
              <div className="alert alert-success">{successMessage}</div>
            )}
            {createError && (
              <div className="text-danger mb-2">
                {createMessage || t("admin_users_pages.create_failed")}
              </div>
              )}
              <div className="form-group mb-3">
                <label className="text-black font-w500">{t("admin_common.name")}</label>
                <input
                  type="text"
                  className="form-control"
                  name="fullName"
                  value={formState.fullName}
                  onChange={handleChange}
                  placeholder={t("admin_common.name")}
                />
              </div>
              <div className="form-group mb-3">
                <label className="text-black font-w500">{t("admin_common.email")}</label>
                <input
                  type="email"
                  className="form-control"
                  name="email"
                  value={formState.email}
                  onChange={handleChange}
                  placeholder={t("admin_common.email")}
                />
              </div>
              <div className="form-group mb-3">
                <label className="text-black font-w500">{t("admin_users_pages.temp_password")}</label>
                <input
                  type="password"
                  className="form-control"
                  name="tempPassword"
                  value={formState.tempPassword}
                  onChange={handleChange}
                  placeholder={t("admin_users_pages.temp_password")}
                />
              </div>
              <div className="form-group mb-3">
                <label className="text-black font-w500">{t("admin_common.role")}</label>
                <input
                  type="text"
                  className="form-control"
                  name="role"
                  value={formState.role}
                  onChange={handleChange}
                  placeholder={t("admin_common.role")}
                />
              </div>
              <div className="form-group mb-3">
                <label className="text-black font-w500">{t("admin_users_pages.business_id_optional")}</label>
                <input
                  type="text"
                  className="form-control"
                  name="businessId"
                  value={formState.businessId}
                  onChange={handleChange}
                  placeholder={t("admin_common.business_id")}
                />
              </div>
              <button
                type="button"
                className="btn btn-success"
                onClick={handleSubmit}
                disabled={createLoading}
              >
                {t("admin_common.save")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UsersCreatePage;
